import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" 返回首页 ")

import { useRouter } from 'vue-router'
import notification from 'ant-design-vue/es/notification'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter() // 必须定义在函数外边

const toHome = (): void => {
  router.push({ path: '/' }).catch(err => notification.error({ message: err }))
}

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_result = _resolveComponent("a-result")!

  return (_openBlock(), _createBlock(_component_a_result, {
    status: "404",
    title: "404",
    "sub-title": "找不到此页面"
  }, {
    extra: _withCtx(() => [
      _createVNode(_component_a_button, {
        type: "primary",
        onClick: toHome
      }, {
        default: _withCtx(() => [
          _hoisted_1
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})